import React, { useContext, useEffect, useState } from "react";
import ApplicationContext from './ApplicationContext';
import {getDataWithFetch} from './Utils';
import "../assets/css/modal.css";

const ResetTopStoriesModal = ({ setOpenModal }) => {
	const data = useContext(ApplicationContext);
	const [clickedSave, setClickedSave] = useState(false);
	const [statusText, setStatusText] = useState("");

	useEffect(() => {
		if (clickedSave && data.BASE_URL) {
			(async() => {
				const url = `${data.BASE_URL}index.php/news_data/update_reset_top_stories`;
				// console.log('DEBUG:  Admin - ', url);
				const json = await getDataWithFetch(url);
				setStatusText(`Reset ${json?.COUNT} Top Stories.`);
				data.resetTopStoriesCount++;

				// console.log('DEBUG:  output of update_reset_top_stories - ', typeof json, json);
				setClickedSave(false);
			})();
		}
	}, [data, clickedSave]);

	return (
		<div className="modalBackground">
			<div className="modalContainer">
				<div className="titleCloseBtn">
					<button onClick={() => {setOpenModal(false)}}>X</button>
				</div>
				{/* We add textAlign in here becasue model.css is reused for the credit card dialog so customize this one here. */}
				<div className="title" style={{textAlign:"center"}}>
					<h1>Are you sure you want to remove all the top stories?  This operation cannot be undone!</h1>
					<div className="drabable-status-text" style={{display: statusText?.length ? 'block' : 'none'}}>
						<p className="paragraph-status-text">{statusText}</p>
					</div>

				</div>
				<div className="footer">
					<button onClick={() => {setOpenModal(false)}} id="cancelBtn">Cancel</button>
					<button onClick={() => {setClickedSave(true)}}>Continue</button>
				</div>
			</div>
		</div>
	);
};

export default ResetTopStoriesModal;
